export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9113.1c48c332.jpg";